<template>

  <div>

    <div class="ui large breadcrumb">
      <div class="bold section">{{ title }}</div>
    </div>

    <bookmark-button :label="title" />

    <div class="ui divider"></div>

    <div class="ui grid">      
      <div class="eleven wide computer sixteen wide tablet sixteen wide mobile column">
        <button class="ui blue button" @click="$refs.formModal.create()">
          <i class="plus icon"></i> Novo Tutor
        </button>
      </div>
      <div class="five wide computer sixteen wide tablet sixteen wide mobile column">
        <div class="ui basic right aligned segment no-padding no-margin">
          <div class="ui form">
            <div class="field">
              <search-input id="owners-search-input" ref="searchInput" @onSearch="search" />
            </div>
          </div>    
        </div> 
      </div>
    </div>

    <data-table id="owners-dtbl" ref="dtbl" :service="service" :attributes="attributes" :fields="fields" @onRowClick="onUpdate" />

    <form-modal ref="formModal" @onSave="refresh" @onRemove="refresh" @onShowAnimals="onShowAnimals" />

  </div>

</template>

<script>
  
  import OwnerService from "@/services/owner-service"
  import FormModal from "./form-modal"
  import { gridPage, onlySimavet } from "@/mixins"

  export default {    

    name: "OwnersPage",

    mixins: [gridPage, onlySimavet],

    data() {
      return {        
        title: "Tutores",
        service: new OwnerService(),
        attributes: ["id", "name", "email", "mobile", "phone", "cgc", "zipCode", "address", "number", "complement", "district", "city", "state"],
        fields: [          
          { prop: "name", label: "Nome" },        
          { prop: "email", label: "E-mail" },                    
          { prop: "mobile", label: "Celular" },
          { prop: "phone", label: "Telefone" },          
        ],
      }
    },

    components: {
      FormModal,
    },

    methods: {

      onUpdate(data) {
        this.$refs.formModal.update(data.row)
      },

      onShowAnimals(owner) {
        this.$router.push(`/entries/owners/${owner.id}/animals`)
      },
    },
  }

</script>
